import { render, staticRenderFns } from "./Pc3.vue?vue&type=template&id=6120b3f8&scoped=true"
import script from "./Pc3.vue?vue&type=script&lang=js"
export * from "./Pc3.vue?vue&type=script&lang=js"
import style0 from "./Pc3.vue?vue&type=style&index=0&id=6120b3f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6120b3f8",
  null
  
)

export default component.exports